module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container flex-column-start page-home"
  }, [(!_vm.$route.query.nonav && !_vm.isFullscreen) ? _c('el-row', {
    staticClass: "header text-white"
  }, [_c('div', {
    staticClass: "expired"
  }, [_c('span', [_vm._v("店铺有效期至：" + _vm._s(_vm.expired_date))]), _vm._v(" "), (_vm.expired_day <= 15) ? _c('i', [_vm._v(_vm._s(_vm.expired_day > 0 ? _vm.expired_day + '天后过期' : '已过期'))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "logo PL-10",
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "text-22"
  }, [_vm._v(_vm._s(_vm.sysShopName || '广州白云店'))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('dl', {
    staticClass: "flex-row-start"
  }, [_c('dt', {
    staticClass: "common-use__title MR-10",
    staticStyle: {
      "height": "60px",
      "overflow": "hidden"
    }
  }, [_vm._v("常用功能")]), _vm._v(" "), _vm._l((_vm.commonModules), function(item, index) {
    return (item.show) ? _c('dd', {
      key: index,
      staticClass: "common-use__item text-16 pointer",
      class: {
        'active': _vm.$route.path === item.path
      },
      staticStyle: {
        "height": "60px",
        "overflow": "hidden"
      },
      on: {
        "click": function($event) {
          return _vm.linkTo(item)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-fw MR-5",
      class: [item.icon]
    }), _vm._v("\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")]) : _vm._e()
  }), _vm._v(" "), (_vm.privilegeObject && _vm.privilegeObject[34]) ? _c('dd', {
    staticClass: "common-use__item text-16 pointer",
    staticStyle: {
      "height": "60px",
      "overflow": "hidden"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/buying/index'
        })
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-fw MR-5 fa-shopping-basket"
  }), _vm._v("\n\t\t\t\t\t报价\n\t\t\t\t\t"), (_vm.peekCount) ? _c('i', [_vm._v(_vm._s(_vm.peekCount))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.privilegeObject && _vm.privilegeObject[32]) ? _c('dd', {
    staticClass: "common-use__item text-16 pointer",
    staticStyle: {
      "height": "60px",
      "overflow": "hidden"
    },
    on: {
      "click": function($event) {
        return _vm.openQxb('main_tab=11&opc_vin=', '查EPC')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-fw MR-5 fa-search"
  }), _vm._v("\n\t\t\t\t\t查EPC\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.privilegeObject && _vm.privilegeObject[33]) ? _c('dd', {
    staticClass: "common-use__item text-16 pointer",
    staticStyle: {
      "height": "60px",
      "overflow": "hidden"
    },
    on: {
      "click": function($event) {
        return _vm.openQxb('main_tab=19&oem=', '查OE')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-fw MR-5 fa-search"
  }), _vm._v("\n\t\t\t\t\t查OE\n\t\t\t\t")]) : _vm._e()], 2)]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo text-right PR-20 flex-row-end",
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "text-16 pointer MR-20 flex-column-center userinfo-item"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom-end",
      "width": "400",
      "popper-class": "message-popper",
      "offset": 30,
      "trigger": "click"
    },
    on: {
      "show": _vm.openMessageList
    }
  }, [_c('div', {
    staticClass: "message-container"
  }, [_c('div', {
    staticClass: "message-box"
  }, [_c('div', {
    staticClass: "message-box-content",
    attrs: {
      "id": "message-box"
    }
  }, [_vm._l((_vm.orderMessageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "message-item",
      on: {
        "click": function($event) {
          return _vm.handleToOrderDetail(item)
        }
      }
    }, [(item.is_read == 0) ? _c('i', {
      staticClass: "red-dot"
    }) : _vm._e(), _vm._v(" "), (item.notify_type == '0') ? _c('img', {
      staticClass: "type-icon",
      attrs: {
        "src": require("@/assets/images/message_type_icon.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.notify_type == '1') ? _c('img', {
      staticClass: "type-icon",
      attrs: {
        "src": require("@/assets/images/message_type_refund.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.notify_type == '2') ? _c('img', {
      staticClass: "type-icon",
      attrs: {
        "src": require("@/assets/images/message_type_approval.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.notify_type == '3') ? _c('img', {
      staticClass: "type-icon",
      attrs: {
        "src": require("@/assets/images/message_type_goods.png")
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "message-content"
    }, [_c('div', {
      staticClass: "message-type"
    }, [_c('span', {
      staticClass: "message-type-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(_vm.filterTime(item.created_at)))])]), _vm._v(" "), _c('div', {
      staticClass: "message-body"
    }, [_c('span', {
      staticClass: "message-tips text_overflow"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), (_vm.orderStatusMap[item.order_status]) ? _c('span', {
      staticClass: "message-status",
      style: ({
        color: _vm.orderStatusMap[item.order_status].color
      })
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.orderStatusMap[item.order_status].name) + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.orderMessageList.length === 0) ? _c('p', {
    staticClass: "no-message-data"
  }, [_vm._v("暂无消息哦")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "footer-container-content"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v("未读" + _vm._s(_vm.unread_count || 0) + "条")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": "",
      "disabled": _vm.orderMessageList.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.handleSetRead('all')
      }
    }
  }, [_vm._v("全部标记已读")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": "",
      "disabled": _vm.orderMessageList.length === 0
    },
    on: {
      "click": _vm.handleClearMessage
    }
  }, [_vm._v("清空记录")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "userinfo-item__message",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [(_vm.unread_count > 0) ? _c('el-badge', {
    staticClass: "userinfo-item__badge",
    attrs: {
      "value": _vm.unread_count > 99 ? '99+' : _vm.unread_count
    }
  }, [_c('i', {
    staticClass: "iconfont iconxiaoxizhongxin",
    staticStyle: {
      "font-size": "20px"
    }
  })]) : _c('i', {
    staticClass: "iconfont iconxiaoxizhongxin",
    staticStyle: {
      "font-size": "20px"
    }
  })], 1)]), _vm._v(" "), _c('audio', {
    ref: "audio",
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "src": "",
      "muted": "",
      "preload": ""
    }
  })], 1), _vm._v(" "), _c('el-dropdown', [_c('div', {
    staticClass: "el-dropdown-link userinfo-inner text-white pointer"
  }, [(false) ? _c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.userInfo.username || _vm.userInfo.shop_name) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.openNotice(1)
      }
    }
  }, [_vm._v("版本信息")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "main flex-h__1 flex-row-start"
  }, [(!_vm.$route.query.nonav && !_vm.isFullscreen) ? _c('div', {
    staticClass: "menu flex-column-start"
  }, [_c('el-menu', {
    staticClass: "flex-h__1 menu-info",
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "collapse": _vm.collapsed,
      "collapse-transition": false,
      "unique-opened": true
    }
  }, [_vm._l((_vm.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf && item.has) ? _c('el-submenu', {
      key: index + '',
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden && child.has) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(child.name) + "\n\t\t\t\t\t\t")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      key: item.children[0].path,
      class: {
        'menu-item-index': item.path == '/index'
      },
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls,
      style: (("color: " + (item.path == '/index' ? '#ff8200' : '') + ";"))
    }), _vm._v(" "), _c('span', {
      style: (("color: " + (item.path == '/index' ? '#ff8200' : '') + ";")),
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.children[0].name) + "\n\t\t\t\t\t\t")])]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle pointer",
    on: {
      "click": _vm.collapse
    }
  }, [_c('span', {
    staticClass: "fa",
    class: [_vm.collapsed ? 'fa-angle-double-right' : 'fa-angle-double-left']
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.contentBol) ? _c('section', {
    staticClass: "content-container flex-w__1 flex-column-start",
    style: (("overflow: " + (_vm.$route.path == '/stock/list' || _vm.isFullscreen ? 'hidden' : 'auto')))
  }, [_c('div', {
    staticClass: "content-wrapper flex-h__1 flex-column-start",
    class: {
      'MT-20': !_vm.isFullscreen && !_vm.noContentMargin,
      'is-fullscreen': _vm.isFullscreen
    }
  }, [_c('transition', {
    attrs: {
      "name": "el-fade-in-linear",
      "mode": "out-in"
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "flex-h__1"
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "flex-h__1"
  }) : _vm._e()], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), (_vm.showIcpBox && !_vm.isFullscreen) ? _c('footer', {
    staticClass: "icp-footer"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/recordQuery",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("ICP备案号：粤ICP备09172001号-5")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-48f93a1a","transformToRequire":{"audio":"src"}}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 931
// module chunks = 116